<template>
  <v-container grid-list-xl>
    <v-card>
      <v-toolbar flat color="teal lighten-5">
        <v-icon left color="teal darken-3">payments</v-icon>
        <v-toolbar-title class="font-weight-bold teal--text text--darken-3">Para Birimleri</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="teal darken-2" dark @click="openCreate">
          <v-icon left>add</v-icon>Yeni Para Birimi
        </v-btn>
      </v-toolbar>

      <v-data-table :headers="headers" :items="currencies" :loading="loading" :rows-per-page-items="[25, 50, { text: 'Tümü', value: -1 }]" class="elevation-0 mt-2">
        <template v-slot:items="props">
          <td class="px-2 font-weight-bold">{{ props.item.code }}</td>
          <td class="px-2">{{ props.item.name }}</td>
          <td class="px-2 text-xs-center">{{ props.item.symbol || '-' }}</td>
          <td class="px-2 text-xs-center">{{ props.item.sortOrder }}</td>
          <td class="px-2 text-xs-center">
            <v-chip small :color="props.item.isActive ? 'green darken-1' : 'grey lighten-1'" text-color="white">
              {{ props.item.isActive ? 'Aktif' : 'Pasif' }}
            </v-chip>
          </td>
          <td class="px-2 text-xs-center">
            <v-btn icon small color="blue darken-1" @click="openEdit(props.item)"><v-icon small>edit</v-icon></v-btn>
            <v-btn icon small color="red darken-1" @click="remove(props.item)"><v-icon small>delete</v-icon></v-btn>
          </td>
        </template>
        <template v-slot:no-data>
          <div class="pa-4 text-xs-center grey--text">{{ loading ? 'Yükleniyor...' : 'Henüz para birimi eklenmemiş.' }}</div>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" max-width="460px" persistent>
      <v-card>
        <v-toolbar flat color="teal lighten-5">
          <v-toolbar-title class="teal--text text--darken-3 font-weight-bold">{{ editId ? 'Para Birimi Düzenle' : 'Yeni Para Birimi' }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-text-field v-model="form.code" label="Kod (TL, USD, EUR)" maxlength="10"></v-text-field>
          <v-text-field v-model="form.name" label="Ad (Türk Lirası)"></v-text-field>
          <v-text-field v-model="form.symbol" label="Sembol (₺, $, €)" maxlength="8"></v-text-field>
          <v-text-field v-model.number="form.sortOrder" label="Sıra" type="number"></v-text-field>
          <v-switch v-model="form.isActive" label="Aktif" color="green darken-1"></v-switch>
        </v-card-text>
        <v-card-actions class="px-3 pb-3">
          <v-spacer></v-spacer>
          <v-btn flat @click="dialog = false">İptal</v-btn>
          <v-btn color="teal darken-2" dark :loading="saving" @click="save">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      saving: false,
      currencies: [],
      dialog: false,
      editId: null,
      form: { code: '', name: '', symbol: '', sortOrder: 0, isActive: true },
    };
  },
  computed: {
    headers() {
      return [
        { text: 'Kod', value: 'code', sortable: true },
        { text: 'Ad', value: 'name', sortable: true },
        { text: 'Sembol', value: 'symbol', sortable: false, align: 'center' },
        { text: 'Sıra', value: 'sortOrder', sortable: true, align: 'center' },
        { text: 'Durum', value: 'isActive', sortable: true, align: 'center' },
        { text: 'İşlem', value: 'actions', sortable: false, align: 'center' },
      ];
    },
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.currencies = (await this.$store.dispatch('cashAccounts/listCurrencies', false)) || [];
      } catch (e) {
        this.currencies = [];
      } finally {
        this.loading = false;
      }
    },
    openCreate() {
      this.editId = null;
      this.form = { code: '', name: '', symbol: '', sortOrder: 0, isActive: true };
      this.dialog = true;
    },
    openEdit(item) {
      this.editId = item.id;
      this.form = { code: item.code, name: item.name, symbol: item.symbol || '', sortOrder: item.sortOrder, isActive: item.isActive };
      this.dialog = true;
    },
    async save() {
      if (!this.form.code || !this.form.name) {
        this.$store.state.message = 'Kod ve ad zorunludur.';
        this.$store.state.dialog = true;
        return;
      }
      this.saving = true;
      try {
        const payload = {
          code: this.form.code.trim(),
          name: this.form.name.trim(),
          symbol: (this.form.symbol || '').trim(),
          sortOrder: Number(this.form.sortOrder) || 0,
          isActive: !!this.form.isActive,
        };
        if (this.editId) {
          await this.$store.dispatch('cashAccounts/updateCurrency', { id: this.editId, payload });
        } else {
          await this.$store.dispatch('cashAccounts/createCurrency', payload);
        }
        this.dialog = false;
        await this.load();
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || 'Kaydedilemedi.';
        this.$store.state.message = msg;
        this.$store.state.dialog = true;
      } finally {
        this.saving = false;
      }
    },
    async remove(item) {
      if (!window.confirm(`${item.code} para birimi silinsin mi?`)) return;
      try {
        await this.$store.dispatch('cashAccounts/deleteCurrency', item.id);
        await this.load();
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || 'Silinemedi.';
        this.$store.state.message = msg;
        this.$store.state.dialog = true;
      }
    },
  },
  async mounted() {
    await this.load();
  },
};
</script>
